/*
 *
 * LocalStorageProvider actions
 *
 */

import {
  REMOVE_SAVED_PLAN,
  UPDATE_SAVED_PLAN_NAME,
  ADD_SAVED_PLAN,
  CHECKED_SAVED_PLAN,
  SET_LAST_VERSION,
  SET_HAS_SEEN_NEW_FEATURES,
  SET_HAS_LOADED_OLD_PLAN,
  CLOSE_PRODUCT_MESSAGE,
} from './constants';

export function removeSavedPlan(code) {
  return {
    type: REMOVE_SAVED_PLAN,
    code,
  };
}

export function updateSavedPlanName(code, name) {
  return {
    type: UPDATE_SAVED_PLAN_NAME,
    code,
    name,
  };
}

export function addSavedPlan(code, image, name, updateLastOpened = true, lastOpened) {
  return {
    type: ADD_SAVED_PLAN,
    code,
    image,
    name,
    updateLastOpened,
    lastOpened,
  };
}

export function checkSavedPlan(code) {
  return {
    type: CHECKED_SAVED_PLAN,
    code,
  };
}

export function setLastVersion(version) {
  return {
    type: SET_LAST_VERSION,
    version,
  };
}

export function setHasSeenNewFeatures(hasSeen) {
  return {
    type: SET_HAS_SEEN_NEW_FEATURES,
    hasSeen,
  };
}

export function setHasLoadedOldPlan(hasLoaded) {
  return {
    type: SET_HAS_LOADED_OLD_PLAN,
    hasLoaded,
  };
}

export function closeBannerMessage(hasClosed) {
  return {
    type: CLOSE_PRODUCT_MESSAGE,
    hasClosed,
  }
}
